import OfficeHours from "@/types/OfficeHours.interface"

interface State {
    officeHours: OfficeHours
}

const defaults = () => {
    return {
        officeHours: null
    }
}

export default {
    state: defaults(),
    mutations: {
        officeHoursReset(state: State): void {
            Object.assign(state, defaults())
        },
        officeHoursSet(state: State, officeHours: OfficeHours): void {
            state.officeHours = officeHours
        }
    },
    actions: {
        officeHoursGet({ commit, getters }): Promise<OfficeHours> {
            //  Assemble the API endpoint
            const url = `${getters.api}/office-hours`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our store office hours
                commit('officeHoursSet', response.data)

                //  Return the office hours as well
                return response.data
            }).catch(() => null)
        },
        officeHoursPut({ commit, getters }, hours: OfficeHours): Promise<OfficeHours> {
            //  Assemble the API endpoint
            const url = `${getters.api}/office-hours`

            //  Send the request
            return window.axios.put(url, hours).then(response => {
                //  Set our store office hours
                commit('officeHoursSet', response.data)

                //  Return the office hours
                return response.data
            }).catch(() => null)
        }

    },
    getters: {
        officeHours (state: State): OfficeHours {
            return state.officeHours
        }
    }
}
